"use strict";
/* eslint-disable @typescript-eslint/no-unused-vars */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TempTestPOINodeInterface = exports.MOCK_LIST_KEY = void 0;
const engine_1 = require("@railgun-community/engine");
const shared_models_1 = require("@railgun-community/shared-models");
const utils_1 = require("../../utils");
exports.MOCK_LIST_KEY = 'test_list';
class TempTestPOINodeInterface extends engine_1.POINodeInterface {
    constructor(engine) {
        super();
        this.engine = engine;
    }
    static getPOISettings(chain) {
        const network = (0, shared_models_1.networkForChain)(chain);
        if (!network) {
            throw new Error(`No network found`);
        }
        const networkPOISettings = network.poi;
        if (!networkPOISettings) {
            throw new Error(`No POI settings found`);
        }
        return networkPOISettings;
    }
    // eslint-disable-next-line class-methods-use-this
    isActive(chain) {
        return TempTestPOINodeInterface.getPOISettings(chain) != null;
    }
    // eslint-disable-next-line class-methods-use-this
    async getPOIsPerList(_chain, listKeys, blindedCommitmentDatas) {
        const allMissing = {};
        blindedCommitmentDatas.forEach(blindedCommitmentData => {
            var _a;
            allMissing[_a = blindedCommitmentData.blindedCommitment] ?? (allMissing[_a] = {});
            listKeys.forEach(listKey => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                allMissing[blindedCommitmentData.blindedCommitment][listKey] =
                    engine_1.TXOPOIListStatus.Missing;
            });
        });
        return allMissing;
    }
    // eslint-disable-next-line class-methods-use-this
    async getPOIMerkleProofs(chain, listKey, proofInputs, railgunTransactionBlockNumber) {
        const { launchBlock } = TempTestPOINodeInterface.getPOISettings(chain);
        if (railgunTransactionBlockNumber < launchBlock) {
            return proofInputs.blindedCommitmentsIn.map(engine_1.createDummyMerkleProof);
        }
        throw new Error('Could not get merkle proofs - no POI node');
    }
    // eslint-disable-next-line class-methods-use-this
    async generateAndSubmitPOI(chain, listKey, proofInputs, blindedCommitmentsOut, txidMerklerootIndex, railgunTransactionBlockNumber) {
        const poiMerkleProofs = await this.getPOIMerkleProofs(chain, listKey, proofInputs, railgunTransactionBlockNumber);
        const finalProofInputs = {
            ...proofInputs,
            poiMerkleroots: poiMerkleProofs.map(merkleProof => merkleProof.root),
            poiInMerkleProofIndices: poiMerkleProofs.map(merkleProof => merkleProof.indices),
            poiInMerkleProofPathElements: poiMerkleProofs.map(merkleProof => merkleProof.elements),
        };
        const progressCallback = (progress) => {
            (0, utils_1.sendMessage)(`Generating POI proof for ${listKey}... ${Math.round(progress * 100)}%`);
        };
        const { proof } = await this.engine.prover.provePOI(finalProofInputs, blindedCommitmentsOut, progressCallback);
        throw new Error('Could not submit POI - no POI node');
    }
}
exports.TempTestPOINodeInterface = TempTestPOINodeInterface;
